import DropdownMenuItem, { DropdownMenuItemProps } from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

type PermissionGateDropdownItemProps = DropdownMenuItemProps & {
  access: AccessResult;
};

const PermissionGateDropdownItem = ({
  access,
  ...menuItemProps
}: PermissionGateDropdownItemProps) => {
  return (
    (access.result || !!access.message) && (
      <DropdownMenuItem
        {...menuItemProps}
        tooltip={access.message}
        isDisabled={!access.result || menuItemProps.isDisabled}
        tooltipWidthMode="maxWidthSm"
      />
    )
  );
};

export default PermissionGateDropdownItem;
